export const PROFILE_DESCRIPTION_CONTAINS_EMAIL_ERROR_CODE = '1013'
export const PROFILE_DESCRIPTION_CONTAINS_URL_ERROR_CODE = '1014'
export const PROFILE_DESCRIPTION_CONTAINS_PHONE_NUMBER_ERROR_CODE = '1015'
export const PROFILE_DESCRIPTION_CONTAINS_HTML_TAG_ERROR_CODE = '1016'
export const PROFILE_DESCRIPTION_CONTAINS_USERNAME_ERROR_CODE = '1020'
export const STORE_DUPLICATE_URL_ERROR_CODE = '1017'
export const INVALID_STORE_URL_ERROR_CODE = '1019'

export const MAX_DESCRIPTION_CHARACTER_LENGTH = 250
